import RoomAllotmentTableView from './RoomAllotmentTableView';

export default RoomAllotmentTableView;